import React, {ReactElement} from 'react';
import StyledPaginationNumber from './styles';
import Props from './typings';

const DOTS = '...';

const PaginationNumber = ({
  number,
  onClick,
  href,
  active,
  disabled = false,
}: Props): ReactElement => {
  return (
    <StyledPaginationNumber
      onClick={(e) => {
        e.preventDefault();
        if (disabled) return;
        onClick(Number(number));
      }}
      $active={active}
      $disabled={disabled}
      aria-label={disabled ? undefined : `Page ${number}`}
      aria-disabled={disabled}
      href={disabled ? undefined : href}
      as={disabled ? 'button' : undefined}
    >
      {number === DOTS ? <>&#8230;</> : number}
    </StyledPaginationNumber>
  );
};

export default PaginationNumber;
